import { useOptionalTourContext } from "../../contexts/TourContext";
import EasyModeTourRunner from "./EasyModeTourRunner";

// No provider means the flow is rendering outside the layout shell, which gets no tour
const EasyModeTour = () => {
   const hasTourProvider = Boolean(useOptionalTourContext());

   return hasTourProvider ? <EasyModeTourRunner /> : null;
};

export default EasyModeTour;
